import {
  Group,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@assetwatch/ui";

const SKELETON_ROWS = Array.from({ length: 6 }, (_, index) => index);

export function AssetsV2HighRiskAssetsTableSkeleton() {
  return (
    <Stack gap={12} aria-busy="true">
      <Group align="center" justify="between" gap={16} wrap="wrap">
        <Group align="center" gap={12}>
          <Skeleton width={184} height={28} />
          <Skeleton width={164} height={18} />
        </Group>
        <Skeleton width={132} height={32} />
      </Group>

      <Group align="center" justify="between" gap={12} wrap="wrap">
        <Group align="center" gap={8}>
          <Skeleton width={92} height={32} />
          <Skeleton width={196} height={32} />
          <Skeleton width={190} height={32} />
        </Group>
        <Skeleton width={240} height={56} />
      </Group>

      <div className="overflow-hidden rounded-(--radius-sm) border border-outline-subtle bg-surface shadow-elevation-1">
        <div className="w-full overflow-x-auto bg-table-row-light-surface">
          <Table
            size="sm"
            aria-label="High-risk assets loading"
            style={{ tableLayout: "fixed" }}
          >
            <TableHeader>
              <TableRow section="header">
                <TableHead variant="starting" width="5%">
                  <Skeleton width={14} height={12} />
                </TableHead>
                <TableHead width="31%">
                  <Skeleton width={56} height={12} />
                </TableHead>
                <TableHead width="15%">
                  <Skeleton width={48} height={12} />
                </TableHead>
                <TableHead width="16%">
                  <Skeleton width={62} height={12} />
                </TableHead>
                <TableHead width="14%">
                  <Skeleton width={72} height={12} />
                </TableHead>
                <TableHead width="19%">
                  <Skeleton width={42} height={12} />
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {SKELETON_ROWS.map((row) => (
                <TableRow key={row}>
                  <TableCell variant="starting" width="5%">
                    <Skeleton width={16} height={16} />
                  </TableCell>
                  <TableCell variant="doubleLine" width="31%">
                    <Skeleton className="w-[72%]" height={16} />
                  </TableCell>
                  <TableCell width="15%">
                    <Skeleton className="w-[76%]" height={16} />
                  </TableCell>
                  <TableCell width="16%">
                    <Skeleton className="w-[82%]" height={16} />
                  </TableCell>
                  <TableCell width="14%">
                    <Skeleton width={46} height={16} />
                  </TableCell>
                  <TableCell width="19%">
                    <Skeleton width={136} height={28} radius="full" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <div className="flex items-center justify-between border-t border-outline-subtle px-(--spacing-16) py-(--spacing-12)">
          <Skeleton width={128} height={16} />
          <Group align="center" gap={12}>
            <Skeleton width={72} height={32} />
            <Skeleton width={88} height={16} />
            <Skeleton width={56} height={32} />
          </Group>
        </div>
      </div>
    </Stack>
  );
}
